
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class WPTextInfoBlock extends Vue {
  @Prop({ default: '' })
  public readonly index?: string | number
}
